export const OPEN_CREATE_ORDER = 'OrdersGlobalContext.OPEN_CREATE_ORDER';
export const SET_ORDER_PHYSICIAN = 'OrdersGlobalContext.SET_ORDER_PHYSICIAN';
export const SET_CHECK_ORDER_PHYSICIAN = 'OrdersGlobalContext.SET_CHECK_ORDER_PHYSICIAN';
export const SET_VERBAL_ORDER_DATE = 'OrdersGlobalContext.SET_VERBAL_ORDER_DATE';
export const SET_CHECK_VERBAL_ORDER_DATE = 'OrdersGlobalContext.SET_CHECK_VERBAL_ORDER_DATE';
export const SET_CONVO_TYPE = 'OrdersGlobalContext.SET_CONVO_TYPE';
export const SET_ORDER_TYPE = 'OrdersGlobalContext.SET_ORDER_TYPE';
export const SET_DISPLAY_CONFIRMATION = 'OrdersGlobalContext.SET_DISPLAY_CONFIRMATION';
export const SET_CREATE_ORDER = 'OrdersGlobalContext.SET_CREATE_ORDER';
export const SET_ORDER_VERIFIED = 'OrdersGlobalContext.SET_ORDER_VERIFIED';
export const SET_SAVED_NOTE = 'OrdersGlobalContext.SET_SAVED_NOTE';
export const SET_ORDER_STATEMENT = 'OrdersGlobalContext.SET_ORDER_STATEMENT';
export const SET_NOTE_TEXT = 'OrdersGlobalContext.SET_NOTE_TEXT';
export const SET_ORDER_LOADER = 'OrdersGlobalContext.SET_ORDER_LOADER';